/* istanbul ignore file */
import { FILTER_TABS, FilterSection } from 'domain/shared/oneStop';
import OneStopDefaultFilterItem, { SectionProps } from 'domain/gpo/oneStop/List/OneStopDefaultFilterItem';
import Box from '@mui/material/Box';

type OneStopFilterLayoutProps = {
  sections: FilterSection[];
  sectionProps: SectionProps;
};

type RecentFilterItemProps = {
  section: FilterSection;
};

const OneStopFilterLayout = ({ sections, sectionProps }: OneStopFilterLayoutProps) => {
  const RecentFilterItem = ({ section }: RecentFilterItemProps) => {
    return <OneStopDefaultFilterItem isIconVisible section={section} sectionProps={sectionProps} />;
  };

  return (
    <Box
      component="ul"
      sx={theme => ({
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        width: '100%',
        flex: '0 0 auto',
        border: 'none',
        listStyle: 'none',
        [theme.breakpoints.up('lg')]: {
          width: '270px',
          '&:not(:empty)': {
            borderRight: '1px solid',
            borderColor: 'border.contrast',
            mr: 4,
            pr: 2.5,
          },
        },
        [theme.breakpoints.down('lg')]: {
          marginTop: 0,
        },
      })}
    >
      {sections.map((section: FilterSection) => {
        const { id } = section;
        if (id === FILTER_TABS.RECENT) {
          return <RecentFilterItem key={id} section={section} />;
        } else {
          return <OneStopDefaultFilterItem key={id} sectionProps={sectionProps} section={section} />;
        }
      })}
    </Box>
  );
};

export default OneStopFilterLayout;
